import React, { useState, useEffect } from 'react';
import AuthService from '../../services/api/auth';
import Helper from '../../helpers';
import { SuccessAlert, ErrorAlert, InfoAlert } from '../../components/adyen/Result';

const PaymenthandleResult = ({ history }) => {
    const [status, setStatus] = useState('');
    const [next, setNext] = useState('/register/status');
    const urlParams = Helper.getUrlParams();

    useEffect(() => {
        if (urlParams && urlParams.next) {
            setNext(urlParams.next);
        }
    }, [urlParams]);

    useEffect(() => {
        if (urlParams.redirectResult) {
            const data = {
                details: {
                    redirectResult: urlParams.redirectResult,
                },
            };
            AuthService.getPaymentResultDetails({ data }).then(result => {
                if (result && result.resultCode) {
                    setStatus(result.resultCode);
                }
                if (result && result.next) {
                    setNext(result.next);
                }
            });
        }
        if (urlParams.status) {
            setStatus(urlParams.status);
        }
    }, [status, urlParams.redirectResult, urlParams.status]);

    return (
        <div className="container-fluid wrapper">
            {status === 'Authorised' && <SuccessAlert />}
            {(status === 'Pending' || status === 'Received') && <InfoAlert />}
            {status === 'Refused' && <ErrorAlert />}

            <button
                type="submit"
                className="btn btn-primary btn-block mt-5"
                onClick={() => {
                    history.push(next);
                }}
            >
                {window.VULOG_TRANSLATE('Continue')}
            </button>
        </div>
    );
};

export default PaymenthandleResult;
